import { useRef, useState } from 'react'
import { AxiosRequestConfig } from 'axios'

import { useRequestCallback } from 'api/use-request-callback'

export const useTypeaheadAsyncSearch = <
  Function extends (query: string, config?: AxiosRequestConfig) => Promise<unknown>,
>(
  fn: Function,
  delay = 400,
) => {
  const typingTimeout = useRef<number | null>(null)
  const requestAbortController = useRef<AbortController | null>(null)

  const { isLoading, response, request } = useRequestCallback<Function>(fn)
  const [typing, setTyping] = useState(false)
  const [isDirty, setIsDirty] = useState(false)

  const search = (searchValue: string) => {
    if (requestAbortController.current) requestAbortController.current?.abort()
    if (typingTimeout.current) clearTimeout(typingTimeout.current)
    setIsDirty(!!searchValue.length)
    setTyping(true)

    typingTimeout.current = window.setTimeout(async () => {
      setTyping(false)
      const controller = new AbortController()

      requestAbortController.current = controller
      try {
        await request(searchValue, {
          signal: controller.signal,
        })
      } catch (e) {
        //TODO: add notification
      }
    }, delay)
  }

  return { searching: isLoading, typing, results: response, search, isDirty }
}
